import React, { useRef, useEffect, useState } from 'react';
import { Image as KonvaImage, Transformer } from 'react-konva';
import useImage from 'use-image';

const ImageManager = ({
  CANVAS_WIDTH,
  CANVAS_HEIGHT,
  uploadedImageSrc,
  selectedImageId, 
  setSelectedImageId, 
}) => {
  const [uploadedImage] = useImage(uploadedImageSrc, "Anonymous");
  const imageRef = useRef(null);
  const transformerRef = useRef(null);

  const [imageAttrs, setImageAttrs] = useState({
    x: CANVAS_WIDTH / 2 - 50,
    y: CANVAS_HEIGHT / 2 - 50,
    scaleX: 1,
    scaleY: 1,
    rotation: 0,
    width: 100,
    height: 100,
  });

  useEffect(() => {
    if (selectedImageId === uploadedImageSrc && transformerRef.current && imageRef.current) {//asdasdads
      transformerRef.current.nodes([imageRef.current]);
    }
  }, [uploadedImageSrc, selectedImageId]);

  const handleDragMove = (e) => {
    const { x, y } = e.target.attrs;
    setImageAttrs((prev) => ({ ...prev, x, y }));
  };

  const handleTransform = () => {
    const node = imageRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    setImageAttrs((prev) => ({
      ...prev,
      width: Math.max(20, node.width() * scaleX), 
      height: Math.max(20, node.height() * scaleY),
    }));
    node.scale({ x: 1, y: 1 });
  };

  if (!uploadedImage) return null;

  return (
    <>
      <KonvaImage
        image={uploadedImage}
        x={imageAttrs.x}
        y={imageAttrs.y}
        width={imageAttrs.width}
        height={imageAttrs.height}
        draggable
        ref={imageRef}
        onDragMove={handleDragMove}
        onTransformEnd={handleTransform}
        onClick={() => setSelectedImageId(uploadedImageSrc)}
      />
      {selectedImageId === uploadedImageSrc && (
        <Transformer
          ref={transformerRef}
          borderStroke="#BC13FE"
          borderStrokeWidth={2}
          borderDash={[10, 5]}
          anchorFill="white"
          anchorStroke="#BC13FE"
          anchorCornerRadius={50}
          enabledAnchors={[
            'top-left', 'top-right', 'bottom-left', 'bottom-right', 
            'top-center', 'bottom-center',
            'middle-left', 'middle-right',
          ]}
          anchorSize={13}
        />
      )}
    </>
  );
};

export default ImageManager;